import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faSpinner,
  faSearch,
  faPlay,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import 'moment/locale/pt-br';
import styles from './styles.module.scss';
import { useGetUser } from '../../../hooks/useGetUser';
import {
  putPopUp,
  postPopUp,
  getPopUpById,
  getPopUpStatus,
  postPopUpImportacaoExcel,
  getListaParticipantePopUp,
  getPopUpUpload,
} from '../../../services/api-auto';
import modeloImportacaoPopUp from '../../../assets/docs/LayoutImportacaoPopUp.xlsx';
import { useDispatch } from 'react-redux';
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import ModalLoading from '../../../components/ModalLoading';
import Modal from '../../../components/Modal/Modal';
import ParticipanteCard from '../../../components/ParticipanteCard';
import Paginacao from '../../../components/Paginacao';
import TableHeader from '../../../components/Table/TableHeader';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  FormGroup,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import FormControl from '@material-ui/core/FormControl';
import MomentUtils from '@date-io/moment';
import { number } from '../../../services/mask';
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const dataInit = {
  nome: '',
  descricao: '',
  mensagem: '',
  periodoIndeterminado: false,
  dataInicio: null,
  dataFim: null,
  camposValidar: '',
  endPointValidar: 'eu/confirmar-pop-up',
  popUpStatusId: '',
  participanteAdicionar: [],
  participanteExcluidos: [],
};

const dataInitValidadores = {
  todos: false,
  nome: false,
  phoneNumber: false,
  email: false,
  dataNascimento: false,
};

const tabelaColunas = ['CNPJ', 'Código Parceiro BV', 'CPF', 'Observação'];

const PopUpDetalhe = () => {
  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));

  const ref = useRef(null);
  const history = useHistory();
  const user = useGetUser();
  const [data, setData] = useState(dataInit);
  const [indicarErros, setIndicarErros] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [status, setStatus] = useState([]);
  const [popUpId, setPopUpId] = useState();
  const [validador, setValidador] = useState(dataInitValidadores);
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ page: 1, pageSize: 10, query: '' });
  const [buscar, setBuscar] = useState('');
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalComplete, setOpenModalComplete] = useState(false);
  const [participantes, setParticipantes] = useState([]);
  const [mostrarImagem, setmostarImagem] = useState({ desk: '', mobi: '' });
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const id = history.location.search.replace('?PopUpId=', '');

  const onFileChange = (event) => {
    let file;
    if (event.target.files && event.target.files[0]) {
      file = event.target.files[0];
      if (
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setDados(file);
      } else {
        showMsgE('Favor escolher arquivos .xlsx');
      }
    }
  };

  const callFileInput = () => {
    ref.current.click();
  };

  const participanteImportacaoExcel = async () => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append('dados', dados);

    try {
      const participantesApi = await postPopUpImportacaoExcel(formdata);

      setParticipantes(
        participantesApi.participantesErroImportacaoExcelResponse
      );
      setData({
        ...data,
        participanteAdicionar:
          participantesApi.participantesImportacaoExcelResponse,
      });

      if (Boolean(participantesApi.sucesso)) {
        showMsgS('Planilha processada com sucesso');
        setLoading(false);
      } else {
        setOpenModalComplete(true);
        showMsgW('Planilha parcialmente importada');
        setLoading(false);
      }
    } catch (e) {
      showMsgE('Planilha não processada');
      setLoading(false);
    } finally {
      setLoading(false);
    }

    setDados(null);
  };

  const validarForm = () => {
    let valid = true;
    let msg = '';

    if (!data.nome) {
      msg += `O campo Nome é obrigatório. `;
      valid = false;
      showMsgW(msg);
    }
    if (!data.periodoIndeterminado && (!data.dataInicio || !data.dataFim)) {
      msg +=
        'As datas são obrigatórias quando o período de vigência for determinado. ';
      valid = false;
      showMsgW(msg);
    }
    if (!data.popUpStatusId) {
      msg += 'O campo Status é obrigatório. ';
      valid = false;
      showMsgW(msg);
    }

    if (!data.descricao) {
      msg += 'O campo Descrição é obrigatório. ';
      valid = false;
      showMsgW(msg);
    }

    // if (!data.mensagem) {
    //   msg += 'O campo Mensagem Personalizada é obrigatório. ';
    //   valid = false;
    //   showMsgW(msg);
    // }

    if (msg) showMsgW(msg);

    setIndicarErros(!valid);
    return valid;
  };

  const getStatus = async () => {
    const status = await getPopUpStatus();
    setStatus(status.data);
  };

  const getPopUpIfEdit = async () => {
    setModalLoading(true);
    try {
      const info = await getPopUpById(id);
      const contentBlock = htmlToDraft(info.mensagem);
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const initialState = EditorState.createWithContent(contentState);
      setEditorState(initialState);



      info.periodoIndeterminado = !info?.dataInicio ?? true;
      info.participantePresentes = info.popUpUsuarios;

      setData(info);
      setmostarImagem({
        desk: info.urlImagemDesktop,
        mobi: info.urlImagemMobile,
      });

      let campos = info.camposValidar.split('|');
      let obj = dataInitValidadores;
      for (let i = 0; i < campos?.length; i++) {
        obj = { ...obj, [campos[i]]: true };
      }
      setValidador(obj);
    } catch (e) {
      showMsgW('Não foi possível carregar os dados');
    }
    setModalLoading(false);
  };

  const enviar = async () => {
    setIndicarErros(false);
    if (validarForm()) {
      data.mensagem = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
      let formdata = data;

      formdata.dataInicio = formdata.periodoIndeterminado
        ? null
        : formdata.dataInicio;
      formdata.dataFim = formdata.periodoIndeterminado
        ? null
        : formdata.dataFim;

      let fields = Object.getOwnPropertyNames(dataInitValidadores);
      let newFields = [];
      for (let i = 0; i < fields?.length; i++) {
        if (fields[i] !== 'todos' && validador[fields[i]])
          newFields.push(fields[i]);
      }
      formdata.camposValidar = newFields.join('|');

      formdata.urlImagemDesktop = mostrarImagem.desk;
      formdata.urlImagemMobile = mostrarImagem.mobi;

      formdata.idsUsuarioAdd = [];
      for (let i = 0; i < data.participanteAdicionar?.length; i++) {
        formdata.idsUsuarioAdd.push({
          userId: data.participanteAdicionar[i].id,
          parceiroId: data.participanteAdicionar[i].idParceiro,
        });
      }

      formdata.idsUsuarioDel = [];
      for (let i = 0; i < data.participanteExcluidos?.length; i++) {
        formdata.idsUsuarioDel.push({
          userId: data.participanteExcluidos[i].id,
          parceiroId: data.participanteExcluidos[i].idParceiro,
        });
      }

      if (id) {
        setModalLoading(true);
        try {
          let info = await putPopUp(id, formdata);
          showMsgS('Dados salvos com sucesso!');
          setTimeout(() => {
            history.push('/pop-up');
          }, 2000);
        } catch (e) {
          showMsgE('Ocorreu um erro ao salvar os dados');
        }
        setModalLoading(false);
      } else {
        setModalLoading(true);
        try {
          let info = await postPopUp(formdata);
          showMsgS('Dados salvos com sucesso!');
          setTimeout(() => {
            history.push('/pop-up');
          }, 2000);
        } catch (e) {
          showMsgE('Ocorreu um erro ao salvar os dados');
        }
        setModalLoading(false);
      }
    }
  };

  const findParticipantesCadastrados = async () => {
    setModalLoading(true);
    try {
      let f = { ...filter, query: buscar, page: 1, popUpId: popUpId };
      setFilter(f);
      const info = await getListaParticipantePopUp(f);

      setData({
        ...data,
        participantePresentes: info.data.items,
      });
      setMaxPage(info.data.totalPages);
      setModalLoading(false);
    } catch (e) {
      showMsgE('Ocorreu um erro e não foi possível carregar dados');
    } finally {
      setModalLoading(false);
    }
  };

  const removerParticipante = (participante) => {

    let adicionados = [...data.participanteAdicionar];
    let index = adicionados.filter((item) => item.cpf === participante.cpf);
    if (index >= 0) {
      adicionados.splice(index, 1);
      setData({ ...data, participanteAdicionar: adicionados });
    }
  };

  const deletarParticipante = (participante) => {
    let listaCadastrados =
      data?.participantePresentes?.length > 0
        ? [...data.participantePresentes]
        : [];
    let listaExcluidos =
      data?.participanteExcluidos?.length > 0
        ? [...data.participanteExcluidos, participante]
        : [participante];

    let index = listaCadastrados.findIndex(
      (item) => item.cpf === participante.cpf
    );

    if (index >= 0) {
      listaCadastrados.splice(index, 1);
      setData({
        ...data,
        participantePresentes: listaCadastrados,
        participanteExcluidos: listaExcluidos,
      });
    }
  };

  const changeValidador = async (value, checked) => {
    if (value === 'todos') {
      let fields = Object.getOwnPropertyNames(dataInitValidadores);
      let obj = {};
      for (var i = 0; i < fields?.length; i++)
        obj = { ...obj, [fields[i]]: checked };

      setValidador(obj);
    } else {
      setValidador({
        ...validador,
        [value]: checked,
      });
    }
  };

  useEffect(() => {
    let fields = Object.getOwnPropertyNames(dataInitValidadores);
    let todos = true;
    for (var i = 0; i < fields?.length; i++)
      if (fields[i] !== 'todos' && !validador[fields[i]]) {
        todos = false;
        break;
      }
    for (var i = 0; i < fields?.length; i++)
      if (fields[i] === 'todos' && validador[fields[i]] !== todos) {
        setValidador({
          ...validador,
          [fields[i]]: todos,
        });
        break;
      }
  }, [validador]);

  useEffect(() => {
    getStatus();
    const id = new URLSearchParams(history.location.search).get('PopUpId');
    if (id) {
      getPopUpIfEdit(id);
    }
  }, []);


  return (
    <>
      {user.perfilAcesso === 'Master' && (
        <>
          <div className={styles.wrapper}>
            <div className={styles.title}>
              Cadastro de Pop-Up
              <button
                className={styles.backButton}
                onClick={() => {
                  history.goBack();
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>

            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div
                  className={styles.card}
                  style={{ padding: '16px 16px 6px 16px' }}
                >
                  <FormControl className={styles.quarter}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, nome: e.target.value });
                      }}
                      label="Nome"
                      value={data?.nome}
                      variant="filled"
                      error={indicarErros && !data.nome ? true : false}
                      className="customFilledInput"
                    />
                  </FormControl>
                  <FormControl className={styles.quarter}>
                    <FormControlLabel
                      value="Indeterminado"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={data.periodoIndeterminado}
                          onChange={(e) => {
                            setData({
                              ...data,
                              periodoIndeterminado: !data.periodoIndeterminado,
                            });
                          }}
                        />
                      }
                      label="Indeterminado"
                      className={styles.radioOptions}
                    />
                  </FormControl>
                  <FormControl className={styles.data}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="De"
                        format="DD/MM/yyyy"
                        value={data.dataInicio}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setData({ ...data, dataInicio: novaData });
                        }}
                        className="customFilledInput"
                        error={indicarErros && !data.dataInicio ? true : false}
                        disabled={data.periodoIndeterminado}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl className={styles.data}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Até"
                        format="DD/MM/yyyy"
                        value={data.dataFim}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setData({ ...data, dataFim: novaData });
                        }}
                        className="customFilledInput"
                        error={indicarErros && !data.dataFim ? true : false}
                        disabled={data.periodoIndeterminado}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl className={styles.quarter}>
                    <InputLabel
                      id="select-status-label"
                      className={styles.label}
                    >
                      Selecione o Status
                    </InputLabel>
                    <Select
                      labelId="select-status-label"
                      label="Status"
                      onChange={(e) => {
                        setData({ ...data, popUpStatusId: e.target.value });
                      }}
                      value={data.popUpStatusId}
                      variant="filled"
                      error={indicarErros && !data.popUpStatusId ? true : false}
                      className="customFilledInput"
                    >
                      {status.map((item) => {
                        return (
                          <MenuItem
                            key={item.popUpStatusId}
                            value={item.popUpStatusId}
                          >
                            {item.nome}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl className={styles.full}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, descricao: e.target.value });
                      }}
                      label="Descrição"
                      value={data.descricao}
                      variant="filled"
                      error={indicarErros && !data.descricao ? true : false}
                      className="customFilledInput"
                      multiline
                      rows={2}
                    />
                  </FormControl>

                  <FormControl className={styles.full}>
                    {/* <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, mensagem: e.target.value });
                      }}
                      label="Mensagem Personalizada"
                      value={data.mensagem}
                      variant="filled"
                      error={indicarErros && !data.mensagem ? true : false}
                      className="customFilledInput"
                      multiline
                      rows={2}
                    /> */}

                    <div
                      style={{
                        border: 'solid 1px #eaeaea',
                        borderRadius: 4,
                        borderBottom: '#5ccbe1 solid 4px',
                      }}
                    >
                      <Editor
                        editorState={editorState}
                        wrapperClassName="demo-wrapper"
                        editorClassName="demo-editor"
                        readOnly={mostrarImagem.desk || mostrarImagem.mobi}
                        onEditorStateChange={(e) => {
                          setEditorState(e);
                        }}
                      />
                    </div>
                  </FormControl>
                  <FormControl className={styles.half}>
                    <div className={styles.subtitle}>Configuração</div>
                    <div className={styles.topSpacing}>
                      <div className={styles.subtitleConfiguracao}>
                        Validador de dados
                      </div>
                      <FormControl className={styles.half}>
                        <FormControlLabel
                          value="todos"
                          control={
                            <Checkbox
                              disabled={
                                mostrarImagem.desk || mostrarImagem.mobi
                              }
                              checked={validador.todos}
                              onChange={(e) => {
                                changeValidador(
                                  e.target.value,
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Todos"
                          className={styles.radioOptions}
                        />
                        <FormControlLabel
                          value="nome"
                          control={
                            <Checkbox
                              disabled={
                                mostrarImagem.desk || mostrarImagem.mobi
                              }
                              checked={validador.nome}
                              onChange={(e) => {
                                changeValidador(
                                  e.target.value,
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Nome Completo"
                          className={styles.radioOptions}
                        />
                        {/* <FormControlLabel value="cpf" control={
                                                    <Checkbox checked={validador.cpf}
                                                        onChange={e => { changeValidador(e.target.value, e.target.checked) }}
                                                    />
                                                }
                                                label="CPF" className={styles.radioOptions} /> */}
                        <FormControlLabel
                          value="phoneNumber"
                          control={
                            <Checkbox
                              disabled={
                                mostrarImagem.desk || mostrarImagem.mobi
                              }
                              checked={validador.phoneNumber}
                              onChange={(e) => {
                                changeValidador(
                                  e.target.value,
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Celular"
                          className={styles.radioOptions}
                        />
                        <FormControlLabel
                          value="email"
                          control={
                            <Checkbox
                              disabled={
                                mostrarImagem.desk || mostrarImagem.mobi
                              }
                              checked={validador.email}
                              onChange={(e) => {
                                changeValidador(
                                  e.target.value,
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="E-mail"
                          className={styles.radioOptions}
                        />
                        <FormControlLabel
                          value="dataNascimento"
                          control={
                            <Checkbox
                              disabled={
                                mostrarImagem.desk || mostrarImagem.mobi
                              }
                              checked={validador.dataNascimento}
                              onChange={(e) => {
                                changeValidador(
                                  e.target.value,
                                  e.target.checked
                                );
                              }}
                            />
                          }
                          label="Data de Nascimento"
                          className={styles.radioOptions}
                        />
                      </FormControl>
                    </div>
                  </FormControl>

                  <FormControl className={styles.half}>
                    <div className={styles.blueBackground}>
                      <div className={styles.content}>
                        <div className={styles.card}>
                          <div className={styles.subtitle}>Imagens</div>

                          <div className={styles.divImageList}>
                            <ButtonsImagesCampain
                              disabled={
                                !(
                                  draftToHtml(
                                    convertToRaw(
                                      editorState.getCurrentContent()
                                    )
                                  ).length <= 8
                                ) ||
                                validador.todos ||
                                validador.dataNascimento ||
                                validador.email ||
                                validador.nome ||
                                validador.phoneNumber
                              }
                              versao="Versão Mobile"
                              texto="Destaque de conteúdo para a vitrine do portal."
                              width="400"
                              height="400"
                              widthMM="132.29"
                              heightMM="132.29"
                              obterLink={true}
                              image={mostrarImagem?.mobi}
                              changeImage={(e) => {
                                setmostarImagem((prev) => ({
                                  ...prev,
                                  mobi: e,
                                }));
                              }}
                            />
                            <ButtonsImagesCampain
                              disabled={
                                !(
                                  draftToHtml(
                                    convertToRaw(
                                      editorState.getCurrentContent()
                                    )
                                  ).length <= 8
                                ) ||
                                validador.todos ||
                                validador.dataNascimento ||
                                validador.email ||
                                validador.nome ||
                                validador.phoneNumber
                              }
                              versao="Versão Desktop"
                              texto="Conteúdo no detalhe do benefício."
                              width="1200"
                              height="300"
                              widthMM="317.5"
                              heightMM="79.375"
                              obterLink={true}
                              image={mostrarImagem?.desk}
                              changeImage={(e) => {
                                setmostarImagem((prev) => ({
                                  ...prev,
                                  desk: e,
                                }));
                              }}
                            />

                            {/* <div>
                              <input
                                className="d-none inputUploadDesk"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={fnCarregarImagemDesk}
                              />
                              <img width={100} src={mostrarImagem?.desk} />
                              <button
                                onClick={() => {
                                  document
                                    .querySelector('.inputUploadDesk')
                                    .click();
                                }}
                              >
                                DESKTOP
                              </button>
                            </div>

                            <div>
                              <input
                                className="d-none inputUploadMobile"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                onChange={fnCarregarImagemMobi}
                              />
                              <img width={100} src={mostrarImagem?.mobi} />

                              <button
                                onClick={() => {
                                  document
                                    .querySelector('.inputUploadMobile')
                                    .click();
                                }}
                              >
                                MOBILE
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormControl>

                  <br></br>
                  {id && (
                    <div>
                      <div>
                        <div className={styles.subtitle}>Upload de arquivo</div>
                        <div>
                          Para direcionar o Pop-Up para usuários específicos,
                          siga o modelo abaixo, importe e em seguida clique em
                          processar planilha.
                        </div>
                        {/* <FormControl>
                        <Button
                          href={modeloImportacaoPopUp}
                          download
                          className={'customButton bigButton bold'}
                        >
                          <FontAwesomeIcon
                            icon={faDownload}
                            className={styles.icon}
                          />
                          Baixar modelo de planilha
                        </Button>
                      </FormControl> */}

                        <FormControl>
                          <Button
                            className={`customButton bigButton bold ${
                              dados !== null ? styles.blue : null
                            }`}
                            onClick={() => {
                              history.push('/pop-up-destinatarios/' + id);
                            }}
                          >
                            Importar Base de Participante
                          </Button>
                        </FormControl>

                        <FormControl style={{ display: 'none' }}>
                          <input
                            type="file"
                            onChange={onFileChange}
                            ref={ref}
                          />
                          {/* <Button
                          className={`customButton bigButton bold ${
                            dados !== null ? styles.blue : null
                          }`}
                          onClick={callFileInput}
                        >
                          Adicionar planilha preenchida
                        </Button> */}
                        </FormControl>
                        {/* <FormControl>
                        <Button
                          className={`styles_processar__1ofBc bold`}
                          onClick={participanteImportacaoExcel}
                        >
                          {!loading ? (
                            <>
                              <FontAwesomeIcon
                                icon={faPlay}
                                className={styles.icon}
                              />
                              PROCESSAR PLANILHA
                            </>
                          ) : (
                            <FontAwesomeIcon
                              icon={faSpinner}
                              className={styles.icon}
                              spin={true}
                            />
                          )}
                        </Button>
                      </FormControl> */}
                      </div>
                      <div className={styles.subtitleConfiguracao}>
                        Participantes - Adicionar
                      </div>
                      <div className={styles.addLojasWrapper}>
                        {Boolean(data.participanteAdicionar?.length) ? (
                          data.participanteAdicionar.map((participante) => {
                            return (
                              <ParticipanteCard
                                participante={participante}
                                key={participante.id}
                                remover={removerParticipante}
                              />
                            );
                          })
                        ) : (
                          <div>Nenhum participante nesta lista</div>
                        )}
                      </div>
                      {data.popUpId && (
                        <>
                          <div className={styles.subtitleConfiguracao}>
                            Participantes - cadastrados
                          </div>
                          {Boolean(data.participantePresentes?.length) ? (
                            <div className={styles.searchWrapper}>
                              <TextField
                                type="text"
                                size="small"
                                onChange={(e) => {
                                  setBuscar(e.target.value);
                                }}
                                label="Faça sua busca"
                                value={buscar}
                                variant="filled"
                                multiline
                                className="customFilledInput"
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    findParticipantesCadastrados();
                                    e.preventDefault();
                                  }
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <button
                                      onClick={findParticipantesCadastrados}
                                      className={styles.searchButton}
                                    >
                                      <FontAwesomeIcon icon={faSearch} />
                                    </button>
                                  ),
                                }}
                              />
                            </div>
                          ) : (
                            ''
                          )}

                          <div className={styles.addLojasWrapper}>
                            {Boolean(data?.participantePresentes?.length) ? (
                              data?.participantePresentes?.map(
                                (participante, i) => {
                                  return (
                                    <ParticipanteCard
                                      participante={participante}
                                      key={participante.id}
                                      remover={() =>
                                        deletarParticipante(participante)
                                      }
                                    />
                                  );
                                }
                              )
                            ) : (
                              <div>Nenhum participante nesta lista</div>
                            )}
                          </div>
                          {maxPage > 1 && (
                            <Paginacao
                              maxPage={maxPage}
                              page={page}
                              setPage={setPage}
                            />
                          )}
                        </>
                      )}
                      <div className={styles.subtitleConfiguracao}>
                        Participantes - remover
                      </div>
                      <div className={styles.addLojasWrapper}>
                        {Boolean(data.participanteExcluidos?.length) ? (
                          data?.participanteExcluidos?.map((participante) => {
                            return (
                              <ParticipanteCard
                                participante={participante}
                                key={participante.id}
                              />
                            );
                          })
                        ) : (
                          <div>Nenhum participante nesta lista</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div className={styles.card}>
                  <div className={styles.subtitle}>Ações</div>
                  <button
                    className={styles.encerrar}
                    onClick={() => {
                      if (
                        window.confirm(
                          'Deseja cancelar esta edição? Todos os dados não salvos serão perdidos.'
                        )
                      ) {
                        history.push('/pop-up');
                      }
                    }}
                  >
                    Cancelar
                  </button>
                  <button className={styles.salvar} onClick={enviar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ModalLoading open={modalLoading} size="lg" />
          <Modal
            open={openModalComplete}
            close={() => {
              setOpenModalComplete(false);
            }}
            size={'sm'}
          >
            <div className="pad20">
              <div className="row">
                <div className="col-sm-12">
                  <div className="container">
                    <div className="row">
                      <div className="col-sm-12">
                        <h3 className="mt40">Log de Erro</h3>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="table-responsive">
                          <table className="table">
                            <TableHeader columns={tabelaColunas} />
                            <tbody>
                              {(!participantes ||
                                participantes?.length === 0) && (
                                <tr>
                                  <td colSpan={tabelaColunas?.length}>
                                    {' '}
                                    Sem Registro{' '}
                                  </td>
                                </tr>
                              )}
                              {participantes &&
                                participantes.map((item, index) => (
                                  <tr key={index}>
                                    <td className="col-sm-2"> {item.cnpj} </td>
                                    <td className="col-sm-3">
                                      {' '}
                                      {item.codigoParceiroBV}{' '}
                                    </td>
                                    <td className="col-sm-2"> {item.cpf} </td>
                                    <td className="col-sm-5">
                                      {' '}
                                      {item.resultado}{' '}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 text-center">
                  <button
                    onClick={() => {
                      setOpenModalComplete(false);
                    }}
                    className="btn btn-outline-info btn-lg mt20 padL40 padR40 mr10"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default PopUpDetalhe;
